import { z } from "zod";
import { factSourcesMax, FactSourceSchema } from "./Fact.js";

export const PendingOrganizationSourceSchema = z.enum(["verity"]);
export type PendingOrganizationSource = z.infer<
  typeof PendingOrganizationSourceSchema
>;

export const PendingOrganizationPayloadSchema = z.object({
  websiteUrl: z.url(),
  companyName: z.string().min(1).max(128).optional(),
  facts: z
    .array(
      z.object({
        blockSlug: z.string().min(1),
        content: z.string().min(1).max(8000),
        references: z.array(FactSourceSchema).max(factSourcesMax).optional(),
      }),
    )
    .max(40),
});

export const PostPendingOrganizationRequestSchema = z.object({
  email: z.email().transform((value) => value.trim().toLowerCase()),
  source: PendingOrganizationSourceSchema,
  payload: PendingOrganizationPayloadSchema,
});

export const PostPendingOrganizationResponseSchema = z.object({
  pendingOrganization: z.object({
    id: z.string(),
    email: z.string(),
    expiresAt: z.string(),
  }),
});

export type PendingOrganizationPayload = z.infer<
  typeof PendingOrganizationPayloadSchema
>;

export type PostPendingOrganizationRequest = z.infer<
  typeof PostPendingOrganizationRequestSchema
>;
export type PostPendingOrganizationResponse = z.infer<
  typeof PostPendingOrganizationResponseSchema
>;

export function pendingOrganizationName({
  companyName,
  websiteUrl,
}: Pick<PendingOrganizationPayload, "companyName" | "websiteUrl">) {
  return companyName ?? new URL(websiteUrl).hostname.replace(/^www\./, "");
}
